import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";

const StyledSizeChart = styled.div`
    position: absolute;
    bottom: calc(100% + 0.8rem);
    ${(props) => (props.isLeft ? "left: -2.6rem;" : "right: 0.6rem;")}
    background-color: ${(props) => props.theme.color.darkGrey};
    border-radius: 2px;
    padding: 10px 12px;
    z-index: 10;
    display: ${(props) => (props.isHidden ? "none" : "block")};
`;
const StyledTooltipArrow = styled.div`
  width: 0;
  height: 0;
  border-radius: 2px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid ${(props) => props.theme.color.darkGrey};
  position: absolute;
  ${(props) => (props.isLeft ? "left: 3.4rem;" : "right: 1.2rem;")}
  top: calc(100% - 1px);
`;
const StyledHeader = styled.div`
  display: flex;
  justsify-content: center;
  align-items: center;
  font-size: 0.5rem;
`;

const StyledRow = styled.div`
  display: flex;
  justsify-content: center;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const StyledHeaderColumn = styled.div`
  width: 100px;
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.responsive.mobile} {
    width: 120px;
  }
`;

const StyledColumn = styled.div`
  margin-left: 10px;
  width: 40px;
  text-align: center;
  color: ${(props) => props.theme.color.grey};

  ${(props) => props.theme.responsive.mobile} {
    width: 80px;
  }
`;

const StyledValue = styled.div`
  font-size: 0.6rem;
  font-weight: bold;
  margin-left: 10px;
  width: 40px;
  text-align: center;
  color: ${(props) => props.theme.color.smoke};

  ${(props) => props.theme.responsive.mobile} {
    width: 80px;
  }
`;

const StyledHeaderTitle = styled.div`
  font-weight: bold;
  color: white;
`;

const StyledHeaderSubtitle = styled.div`
  color: ${(props) => props.theme.color.grey};
  font-size: 0.5rem;
  line-height: 0.5rem;
`;

const SizeTooltip = ({ isLeft, isHidden, ...props }) => {
  const intl = useIntl();
  return (
    <StyledSizeChart isLeft={isLeft} isHidden={isHidden}>
      <StyledTooltipArrow isLeft={isLeft} />
      <>
        <StyledHeader>
          <StyledHeaderColumn></StyledHeaderColumn>
          <StyledColumn>Width</StyledColumn>
          <StyledColumn>Nose Bridge</StyledColumn>
          <StyledColumn>Temple</StyledColumn>
        </StyledHeader>
        <StyledRow>
          <StyledHeaderColumn>
            <StyledHeaderTitle>
              {intl.formatMessage({ id: `product.sizes.S.name` })}
            </StyledHeaderTitle>
            <StyledHeaderSubtitle>
              {intl.formatMessage({
                id: `product.sizes.S.description`,
              })}
            </StyledHeaderSubtitle>
          </StyledHeaderColumn>
          <StyledValue>46</StyledValue>
          <StyledValue>22.5</StyledValue>
          <StyledValue>145</StyledValue>
        </StyledRow>
        <StyledRow>
          <StyledHeaderColumn>
            <StyledHeaderTitle>
              {intl.formatMessage({ id: `product.sizes.M.name` })}
            </StyledHeaderTitle>
            <StyledHeaderSubtitle>
              {intl.formatMessage({
                id: `product.sizes.M.description`,
              })}
            </StyledHeaderSubtitle>
          </StyledHeaderColumn>
          <StyledValue>48</StyledValue>
          <StyledValue>24</StyledValue>
          <StyledValue>147</StyledValue>
        </StyledRow>
        <StyledRow>
          <StyledHeaderColumn>
            <StyledHeaderTitle>
              {intl.formatMessage({ id: `product.sizes.L.name` })}
            </StyledHeaderTitle>
            <StyledHeaderSubtitle>
              {intl.formatMessage({
                id: `product.sizes.L.description`,
              })}
            </StyledHeaderSubtitle>
          </StyledHeaderColumn>
          <StyledValue>52</StyledValue>
          <StyledValue>25</StyledValue>
          <StyledValue>150</StyledValue>
        </StyledRow>
      </>
    </StyledSizeChart>
  );
};

export default SizeTooltip;
